import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonColor, ButtonSize } from '@widgets/eop-button/eop-button.component';
import { IconColor } from '@widgets/eop-icon/eop-icon.component';
import { environment } from 'environments/environment';

@Component({
  selector: 'eop-no-tariff-info',
  standalone: false,
  templateUrl: './no-tariff-info.component.html',
  styleUrl: './no-tariff-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoTariffInfoComponent {
  protected readonly ButtonSize = ButtonSize;
  protected readonly IconColor = IconColor;
  protected readonly ButtonColor = ButtonColor;

  protected openMoreInfo() {
    window.open(environment.assignEVTariffsLinkDocUrl, '_blank', 'noopener,noreferrer');
  }
}
